var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "list-user"
  }, [_c('div', {
    staticClass: "actions"
  }, [_c('a', {
    on: {
      "click": function ($event) {
        return _vm.openView('detail');
      }
    }
  }, [_vm._v($t("obrz2", "详情"))])]), _c('pro-table', _vm._b({
    staticClass: "pro-table"
  }, 'pro-table', _vm.config, false))], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };